import { Component, OnInit } from '@angular/core';
import { Users } from '../../../model/users';
import { UsersService } from '../../../service/component_dependent/users/users.service';
import { StorageService } from '../../../service/managers/storage.service';
import { Router } from '@angular/router';
import { RouterManagerService } from '../../../service/managers/router-manager.service';
import { NotifierService } from '../../../service/component_dependent/notifier.service';
import { PermissionService } from '../../../service/component_dependent/permission.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  protected user: Users;

  protected loading = false;

  constructor(private usersService: UsersService, private storageService: StorageService,
    private router: Router, private routerManagerService: RouterManagerService,
    private notifierService: NotifierService, private permissionService: PermissionService) {

    this.user = new Users();
    this.routerManagerService.restrictDoubleLoginAuthorizedUser();

  }

  ngOnInit() {

  }

  protected onSubmit() {
    this.loading = true;

    this.usersService.loginUser(this.user).subscribe(
      (data: any) => {
        this.loading = false;
        this.storageService.storeToLocalStorage("access_token", data.data.access_token);
        this.storageService.storeToLocalStorage("user", JSON.stringify(data.data.user));
        this.storageService.storeToLocalStorage("permissions", JSON.stringify(data.data.permissions));
        
        let user = data.data.user
        user['permissions'] = data.data.permissions;
        this.notifierService.showSuccess(data.message);
        this.router.navigateByUrl("/smsblast");
        
        // this.permissionService.getPermissionsByUserID(JSON.parse(data.data.user).id).subscribe(
        //   (dataPermission: any) => {
        //     var obj = JSON.parse(data.data.user);
        //     obj['permissions'] = dataPermission.data;
        //     this.storageService.storeToLocalStorage("user", JSON.stringify(obj));
        //     this.notifierService.showSuccess(data.message);
        //     this.router.navigateByUrl("/smsblast");
        //   }, (errorPermission: any) => {
        //     this.notifierService.showError(errorPermission.error.message);
        //   }
        // )
      },
      (error: any) => {
        this.loading = false;
        this.notifierService.showError(error.error.message);
      },
    )
  }
}
